var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsoleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18C22 19.6569 20.6569 21 19 21H5C3.34314 21 2 19.6568 2 18V12V8.5V6.00001C2 4.34315 3.34314 3.00001 4.99999 3.00001L8 3H12H19C20.6569 3 22 4.34315 22 6V18ZM20 6C20 5.44772 19.5523 5 19 5H12H8L5 5.00001C4.44771 5.00001 4 5.44772 4 6.00001V6.99999H20V6ZM4 8.99999H20V18C20 18.5523 19.5523 19 19 19H5C4.44771 19 4 18.5523 4 18V12V8.99999ZM14.8392 12.5439C15.1395 12.0804 15.0073 11.4612 14.5439 11.1608C14.0804 10.8605 13.4612 10.9926 13.1608 11.4561L11.3734 14.214L10.8178 13.4245C10.5 12.9728 9.87617 12.8644 9.42451 13.1822C8.97285 13.5 8.86436 14.1238 9.1822 14.5755L10.5896 16.5755C10.7808 16.8471 11.0944 17.0061 11.4265 16.9998C11.7586 16.9935 12.0659 16.8226 12.2466 16.5439L14.8392 12.5439Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleCheck);
export default __webpack_public_path__ + "static/media/console_check.a810cb488aff97176c844b88b5479bee.svg";
export { ForwardRef as ReactComponent };